import React from 'react';
import classnames from 'classnames';
import styles from './CreateDataProviderModal.module.scss';
import { Link } from 'react-router-dom';
import Avatar from 'v2/Avatar/Avatar';
import { DataVendor } from 'v2/models';
import defaultCompanyAvatar from 'v2/images/defaultCompanyAvatar.png';
import { TranslationKeys } from 'translations';
import { useTranslation } from 'react-i18next';

interface ExistingDataVendorBoxProps {
  dataVendor: DataVendor;
}

const ExistingDataVendorBox = ({ dataVendor }: ExistingDataVendorBoxProps) => {
  const { t } = useTranslation();

  return (
    <>
      <p className={classnames(styles.existingVendorMessage)}>
        Whoops! It looks like a {t(TranslationKeys.company_one)} with this
        domain already exists.
      </p>
      <div className={classnames(styles.existingVendorBox)}>
        <Avatar
          url={dataVendor?.avatar_url || defaultCompanyAvatar}
          className={classnames(styles.existingVendorAvatar)}
        />
        <div className={classnames(styles.existingVendorInfo)}>
          <p className={classnames(styles.existingVendorName)}>
            {dataVendor.name}
          </p>
          <p className={classnames(styles.existingVendorDomain)}>
            {dataVendor.domain}
          </p>
        </div>
        <Link
          to={{
            pathname: `/data-provider-details/${dataVendor.id}/detail`,
            state: {
              counterToGoBack: -1,
            },
          }}
          className={classnames(styles.contactName)}
        >
          View {t(TranslationKeys.company_one)}
        </Link>
      </div>
    </>
  );
};

export default ExistingDataVendorBox;
